const componentsComboboxDeviceMultiSelectComboboxEn = {
  clearAllDeviceOptions: 'Clear all selections'
};
export default componentsComboboxDeviceMultiSelectComboboxEn;